module.exports = __webpack_public_path__ + "media/images/bullet-23f6124a2b418917ca7b5ad7c660192d.png";